import { db } from 'firebaseConfig';
import {
  collection,
  getDocs,
  addDoc,
  query,
  limit,
  orderBy,
  startAfter,
  QueryDocumentSnapshot
} from 'firebase/firestore';
import { converter } from 'converter';
import { BookListType } from 'pages/G001/View/Main/types';
import { Dispatch, SetStateAction } from 'react';
import { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  cardInfoErea: {
    padding: '20px',
    width: '100%',
    display: 'grid',
    gridTemplateColumns: 'repeat( auto-fill, minmax(270px,1fr) )',
    gridGap: '30px',
    justifyContent: 'center',
    backgroundColor: '#F0FFF4',
  },
  card: {
    height: 535,
    width: 270,
    display: 'grid',
    gridGap: '5px',
    gridAutoRows: '380px 150px',
    placeItems: 'center',
    margin: '0 auto',
  },
  cardInfo: {
    height: 150,
    width: 270,
    padding: '0px 10px',
  },
  link: {
    display: 'block',
    margin: 'auto',
  },
  img: {
    display: 'block',
    margin: 'auto',
    width: '100%',
    height:'100%',
    objectFit: 'cover'
  },
});

// 画面終了確認ダイアログ表示
const onBeforeUnload = async (e: BeforeUnloadEvent) => {
  // 固定記載（クローズイベントを一時停止するため）
  e.preventDefault();
  // 固定記載（ChromeではreturnValueが必須）
  e.returnValue = '';

};

const handleWindowClosing = async () => {
  await addNews()
  console.log("aaaaaaaaa")
};

export const useInit = () => {
  const classes = useStyles();
  const [books, setBooks] = useState<Array<BookListType>>([]);
  const [lastVisible, setLastVisible] = useState<QueryDocumentSnapshot<BookListType> | null | undefined>(
    null
  );
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    (async () => {
      await getBooklist(lastVisible, setLastVisible, setBooks, setHasMore);
    })();
  }, []);
  console.log('books:', books);

  useEffect(() => {
    window.addEventListener('beforeunload', onBeforeUnload);
    window.addEventListener('pagehide', handleWindowClosing, false);
    return () => {
      window.removeEventListener('beforeunload', onBeforeUnload);
      window.removeEventListener('pagehide', handleWindowClosing, false);
    };
  }, []);

  return { classes, books, setBooks, lastVisible, setLastVisible, setHasMore, hasMore };
};

function addNews() {
  addDoc(collection(db, 'news').withConverter(converter<Omit<BookListType, 'id'>>()), {
      isbn13: '',
      isbn10: '',
      title: 'aaaa',
      author: '',
      publisher_name: '',
      publish_date: '',
      limit_days: '',
      amazon_url: '',
      amazon_img_src: '',
      tweet_message_amazon: '',
      update_time: '',
    });
    console.log("addNews")
}

// 新刊情報
export async function getBooklist(
  lastVisible: QueryDocumentSnapshot<BookListType> | null | undefined,
  setLastVisible: Dispatch<SetStateAction<QueryDocumentSnapshot<BookListType> | null | undefined>>,
  setData: Dispatch<SetStateAction<BookListType[]>>,
  setHasMore: Dispatch<SetStateAction<boolean>>
) {
  let collRef = null
  if(lastVisible){
    collRef = query(
      collection(db, 'book_list').withConverter(converter<BookListType>()),
      orderBy('publish_date', 'desc'),
      startAfter(lastVisible),
      limit(50)
    );
  }else{
    collRef = query(
      collection(db, 'book_list').withConverter(converter<BookListType>()),
      orderBy('publish_date', 'desc'),
      limit(50)
    );
  }
  const snapshot = await getDocs(collRef);
  console.log("snapshot",snapshot.docs)

  // Get the last visible document
  lastVisible = snapshot.docs[snapshot.docs.length - 1];
  console.log('lastVisible:', lastVisible);
  setLastVisible(lastVisible);

  const data = snapshot.docs.map((doc) => doc.data());
  setData((prev) => [...prev, ...data]);
}





